import _ from 'lodash';

import * as MealTypes from 'PointOfSale/modules/mealTypes/state/types';
import * as SetDateAndSiteTypes from 'PointOfSale/modules/setDateAndSite/state/types';
import { DB_TABLE_NAMES } from 'Common/Constants';
import { reorderList } from 'PointOfSale/modules/common/helpers';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import * as CommonTypes from './types';
import { extractServedItemOrder } from 'PointOfSale/modules/common/helpers';
/**
  {
    [TableName]: null,
    ...
  }
 */
const INITIAL_OFFLINE_ERRORS_STATE = DB_TABLE_NAMES.reduce(
  (acc, key) => ({
    ...acc,
    [key]: null,
  }),
  {}
);

export const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  servingSites: [],
  sites: [],
  nutritionCodes: [],
  servedItems: [],
  servedItemsOrder: {
    [MealTypesEnum.Breakfast]: [],
    [MealTypesEnum.Lunch]: [],
    [MealTypesEnum.Supper]: [],
    [MealTypesEnum.Other]: [],
  },
  taxRatesByStatus: [],
  itemCategories: [],
  currentTransaction: {},
  writeTransactionError: null,
  keypadState: {
    readingLeft: false,
    readingRight: false,
  },
  /** Keep track of errors when interacting with indexedDB */
  offlineErrors: INITIAL_OFFLINE_ERRORS_STATE,
  viewCurrentStudentHistory: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CommonTypes.SET_VIEW_CURRENT_STUDENT_HISTORY:
      return {
        ...state,
        viewCurrentStudentHistory: payload,
      };
    case CommonTypes.WRITE_TRANSACTION_FETCH_ERROR:
      return {
        ...state,
        writeTransactionError: payload,
      };
    case CommonTypes.WRITE_TRANSACTION_FETCHING:
      return {
        ...state,
        fetching: payload,
        writeTransactionError: null,
      };
    case CommonTypes.GET_POS_DATA_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case CommonTypes.GET_POS_DATA_FETCH:
      return {
        ...state,
        nutritionCodes: payload.nutritionCodes,
        servedItems: payload.servedItems,
        itemCategories: payload.itemCategories,
        servedItemsOrder: payload.servedItemsOrder,
        taxRatesByStatus: payload.taxRatesByStatus,
      };
    case CommonTypes.RESET_CURRENT_TRANSACTION:
      return {
        ...state,
        currentTransaction: {},
      };
    case CommonTypes.UPDATE_CURRENT_TRANSACTION:
      return {
        ...state,
        currentTransaction: payload,
      };
    case SetDateAndSiteTypes.GET_SERVING_SITES_FETCH:
      return {
        ...state,
        servingSites: payload,
      };
    case CommonTypes.POS_SET_SITES:
      return {
        ...state,
        sites: payload,
      };
    case SetDateAndSiteTypes.UPDATE_SERVING_SITE_MEAL_COUNT:
      const sites = [...state.servingSites];
      const index = sites.findIndex(s => s.Id === payload.SiteId);

      if (sites[index]) {
        sites[index]['mealCount'] = payload.MealCount;
      }

      return {
        ...state,
        servingSites: sites,
      };
    case CommonTypes.WRITE_LOCAL_ERROR:
      return {
        ...state,
        offlineErrors: {
          ...state.offlineErrors,
          [payload.type]: payload.error,
        },
      };
    case CommonTypes.RESET_WRITE_LOCAL_ERROR:
      return {
        ...state,
        offlineErrors: {
          ...state.offlineErrors,
          [payload.type]: null,
        },
      };
    case CommonTypes.GET_POS_DATA_ERROR:
      return {
        ...state,
        fetchError: payload,
      };
    case CommonTypes.SET_KEYPAD_READING_LEFT:
      return {
        ...state,
        keypadState: {
          ...state.keypadState,
          readingLeft: payload,
        },
      };
    case CommonTypes.SET_KEYPAD_READING_RIGHT:
      return {
        ...state,
        keypadState: {
          ...state.keypadState,
          readingRight: payload,
        },
      };

    case CommonTypes.MOVE_ITEM: {
      let order = reorderList(
        state.servedItemsOrder[payload.itemId[0]],
        payload.startPosition,
        payload.endPosition
      );

      const servedItemsOrder = { ...state.servedItemsOrder };

      servedItemsOrder[payload.itemId[0]] = order;

      return {
        ...state,
        servedItemsOrder,
      };
    }

    case MealTypes.UPDATE_SERVED_ITEMS: {
      return {
        ...state,
        servedItemsOrder: extractServedItemOrder(payload),
      };
    }
    case MealTypes.TOGGLE_SERVED_ITEM_SELECTION:
      let servedItemsOrder = { ...state.servedItemsOrder };

      const selected = _.isNil(payload.selected)
        ? !payload.item.selected
        : payload.selected;

      if (selected) {
        if (
          !servedItemsOrder[payload.item.ItemId[0]].includes(
            payload.item.ItemId
          )
        ) {
          servedItemsOrder[payload.item.ItemId[0]].push(payload.item.ItemId);
        }
      } else {
        servedItemsOrder[payload.item.ItemId[0]] = servedItemsOrder[
          payload.item.ItemId[0]
        ].filter(i => i !== payload.item.ItemId);
      }

      return {
        ...state,
        servedItemsOrder,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/state/reducer.js